// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAMiQ7mR7DExKkIvJLaQ23IDAvfH_lwjRA",
    authDomain: "jmp-heating.firebaseapp.com",
    projectId: "jmp-heating",
    storageBucket: "jmp-heating.appspot.com",
    messagingSenderId: "540610032992",
    appId: "1:540610032992:web:fe3eb9cf888f0fbaab5a05",
  },
};

